import { render, staticRenderFns } from "./FormEmployee.vue?vue&type=template&id=28d2b664&scoped=true"
import script from "./FormEmployee.vue?vue&type=script&lang=js"
export * from "./FormEmployee.vue?vue&type=script&lang=js"
import style0 from "./FormEmployee.vue?vue&type=style&index=0&id=28d2b664&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d2b664",
  null
  
)

export default component.exports